import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.qs-checks-constants';
import * as api from '../../../clients/qschecks';

@Injectable()
export class QschecksQsChecksConstantsEffects {

    QsChecksConstants$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_QS_CHECKS_CONSTANTS),
        mergeMap((x: ac.GetQsChecksConstantsAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getQsChecksConstants().pipe(
                map((result: any) => {
                    return new ac.GetQsChecksConstantsErfolgreichAction(result, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetQsChecksConstantsFehlerAction(error, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.QsChecksTemplatesService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.QsChecksTemplatesService {
        if (this.service === null) {
            this.service = this.injector.get(api.QsChecksTemplatesService);
        }
        return this.service;
    }
}
